import SceneItem from '../scenes/scene/scene';
import React from 'react';
import { useVideoContext } from '../../../hooks/use-video';
import { GLOBAL_SCENE_INDEX } from '@monorepo/types';

const GlobalScene = () => {
  const { globalScene } = useVideoContext();

  if (!globalScene) {
    return null;
  }

  return (
    <div className="global-scene">
      <SceneItem
        key={'global'}
        sceneId={globalScene._id}
        sceneNumber={GLOBAL_SCENE_INDEX}
        currentTime={0}
        isGlobal={true}
      />
    </div>
  );
};

export default GlobalScene;
